document.addEventListener("DOMContentLoaded", () => {
  const inputSearch = document.querySelector(`#cmdk-input`);
  if (!inputSearch) return;

  let debounceTimer;
  inputSearch.addEventListener("input", (e) => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      window.dispatchEvent(new Event('scroll'));
    }, 300);
  });
});

const quickView = document.querySelector('.quick-add-modal');

if (quickView) {
  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
        setTimeout(() =>{
          document.dispatchEvent(new Event('bss_b2b:QuickviewLoaded'));
        }, 500)
      }
    }
  });

  observer.observe(quickView, { attributes: true });
}

const cartDrawer = document.querySelector('.cart-drawer__dialog');

if (cartDrawer) {
  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
          BSS_B2B.observer.cartSubject.notifyObserver('CartUpdate', 'CartMutate');
      }
    }
  });

  observer.observe(cartDrawer, { attributes: true });
}